import {
  PERMISSION_CANTILEVER_PARTS_THREAD_EDITOR,
  PERMISSION_CANTILEVER_PARTS_THREAD_VIEWER,
  PERMISSION_GECKO_INTERNAL_MEMBER,
  RolodexPermissions,
} from 'features/auth'

export const PARTS_DATABASE_PERMISSIONS_LIST: RolodexPermissions[] = [
  PERMISSION_GECKO_INTERNAL_MEMBER,
  PERMISSION_CANTILEVER_PARTS_THREAD_EDITOR,
  PERMISSION_CANTILEVER_PARTS_THREAD_VIEWER,
]
